// extracted by mini-css-extract-plugin
module.exports = {"quotaText":"src-hellospa-components-prep-and-send-quota-alerts-styles__quotaText--2cOsP"};